module.exports = __webpack_public_path__ + "assets/stats-icon.e4777c08.svg";